<template>
  <div :class="{'notes-list card': !isModalsComponent}">
    <template>
      <div v-if="!isModalsComponent" class="card-header d-flex justify-content-between">
        <h5 class="m-0">{{ $t('Notes') }}</h5>
        <b-button v-if="!disableActions" class="float-right p-0" variant="link"
                  v-permission="changePermission"
                  @click="showNoteModal({source: SOURCE_NOTES_TABLE})">
          <font-awesome-icon :icon="'plus'" style="font-size: .9em"/>
          {{ $t('New Note') }}
        </b-button>
      </div>
      <spinner :height="isModalsComponent ? 2: 15" :with-text="isLoadingText" :show="loading"
               v-if="loading"/>
      <div v-if="!loading" :class="{'card-body pt-0 pb-0': !isModalsComponent}">
        <div v-if="notes && notes.length > 0" v-for="(note, index) in notes" :key="note.uuid"
             :class="{'border-bottom': index < notes.length - 1, 'selected-row': selectedUuid === note.uuid}"
             class="pt-2 pb-2">
          <b-media>
            <font-awesome-icon v-if="!disableActions" @click="onRemoveClick(note)" icon="times"
                               v-permission="deletePermission"
                               style="margin-right: .15em" class="text-danger float-right hover-cursor"/>
            <div class="pr-4">
              <span v-if="$hasPermission(changePermission) && !disableActions" style="font-size: 1em"
                    class="title text-primary hover-cursor" @click="onEditClick(note)">
                {{ truncateDescription(note.description) }}
              </span>
              <span v-else style="font-size: 1em">
                {{ truncateDescription(note.description) }}
              </span>
              <br>
              <div class="mt-1">
                <small class="mr-3 text-muted">
                  <font-awesome-icon icon="calendar" class="mr-1"/>
                  {{ $t('Created at') }} {{ note.created_at | toDate }}
                </small>
                <small class="mr-3 text-muted">
                  <font-awesome-icon icon="calendar" class="mr-1"/>
                  {{ $t('Updated at') }} {{ note.updated_at | toDate }}
                </small>
                <small class="text-muted">
                  <font-awesome-icon icon="user" class="mr-1"/>
                  {{ note.created_by.display_name }}
                </small>
              </div>
            </div>
          </b-media>
        </div>
        <no-data-available
            v-if="(!isModalsComponent || !$hasPermission(changePermission)) && (!notes || notes.length === 0)"
            :height="5"/>
        <note-modal/>
      </div>
    </template>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex';
  import NoteModal from "./NoteModal";
  import NoDataAvailable from "../../core/components/common/NoDataAvailable";
  import Spinner from "../../core/components/common/Spinner";
  import {SOURCE_NOTES_TABLE} from "../constants";

  const {mapState, mapActions} = createNamespacedHelpers('notes');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "NoteList",
    components: {NoteModal, Spinner, NoDataAvailable},
    data() {
      return {
        SOURCE_NOTES_TABLE: SOURCE_NOTES_TABLE
      }
    },
    props: {
      objectUuid: {
        type: String,
        required: true
      },
      objectName: {
        type: String,
        required: true
      },
      pluralObjectName: {
        type: String,
        required: true
      },
      changePermission: {
        type: String,
        default: null
      },
      deletePermission: {
        type: String,
        default: null
      },
      truncate: {
        type: [Number, Boolean],
        default: false
      },
      isLoadingText: {
        type: Boolean,
        default: true
      },
      isModalsComponent: {
        type: Boolean,
        default: false
      },
      selectedUuid: {
        type: String,
        default: null
      },
      disableActions: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      ...mapActions(['removeNote', 'showNoteModal', 'getNotes', 'setData']),
      truncateDescription(str) {
        str = this.$options.filters.striptags(str);
        if (!this.truncate) {
          return str;
        } else if (this.truncate === true) {
          return this.$options.filters.truncate(str, 140);
        } else {
          return this.$options.filters.truncate(str, this.truncate);
        }
      },
      onEditClick(item) {
        if (this.isModalsComponent) {
          this.$emit('editClick', item);
        } else {
          this.showNoteModal({object: item, source: SOURCE_NOTES_TABLE})
        }
      },
      async onRemoveClick(note) {
        let success = await this.$confirm(
            this.$i18n.t("Are you sure you want to delete following note?"),
            this.$i18n.t('Note was successfully deleted'),
            this.removeNote,
            note
        );
        if (this.isModalsComponent && success) {
          this.$emit('updateTotalNotes')
        }
      },
    },
    computed: {
      ...mapState({
        notes: state => state.tableData.rows,
        loading: state => state.loading
      }),
    },
    mounted() {
      this.getNotes();
    },
    beforeMount() {
      this.setData({
        object_uuid: this.objectUuid,
        object_name: this.objectName,
        plural_object_name: this.pluralObjectName,
      })
    }
  }
</script>

<style lang="scss" scoped>
  @import "./scss/variables";

  .selected-row {
    background-color: lighten($secondary, 6);
  }

  .media-body {
    width: 100%;
  }
</style>
